import React, { useState } from "react"
import CustomPopup from "../../../../components/Common/CustomPopup";
import config from "../../../../config";
const ContentPopup = ({ resetParent, content, title }) => {
    const closePopup = () => {
        setPopup(null)
        resetParent()
    }
    const [popup, setPopup] = useState({
        open: true,
        title: '',
        inputRef: null,
        titleText: title || "",
        bodyText: content || "",
        subText: '',
        toggle: true,
        handleClose: closePopup,
    })

    return (
        <>
            {popup && <CustomPopup popupDetails={popup} />}
        </>
    )
}

export default ContentPopup;

const supportEmail = config.messages.supportEmail
export const supportContent = <>Need help? Contact us at <a href={`mailto:${supportEmail}`}>{supportEmail}</a> for assistance.</>
export const billingContent = <div className="payment-discard"><p>For any subscription changes or billing inquiries.</p><p>Please email us at <a href={`mailto:${supportEmail}`}>{supportEmail}</a></p></div>
export const enterpriseContent = <div className="payment-discard"><p>You’ve reached your app limit. Need assistance?</p><p>Reach out to us at <a href={`mailto:${supportEmail}`}>{supportEmail}</a></p></div>
